import { useHover } from '@uidotdev/usehooks';
import { Edit2, Trash } from 'iconsax-react';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
interface IProps {
  data: any;
  elData: any;
  setSelectedEl: (value: any) => void;
  i: any;
  visible: any;
  setVisible: React.Dispatch<any>;
  setData: React.Dispatch<any>;
}
const ActionItems: React.FC<IProps> = ({
  data,
  setSelectedEl,
  i,
  setVisible,
  visible,
  setData,
}) => {
  const [editRef, editHovering] = useHover<HTMLDivElement>();
  const [removeRef, removeHovering] = useHover<HTMLDivElement>();

  const handleDelete = () => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData.details.splice(i, 1);
    setData(cloneData);
  };

  return (
    <>
      <IconWrapper
        ref={editRef}
        style={{
          color: editHovering ? theme.colors.blue_500 : theme.colors.dark_200,
        }}
      >
        <Edit2
          size='24'
          onClick={() => {
            setVisible({ ...visible, edit: true });
            setSelectedEl({ data: data?.details?.[i], i: i });
          }}
        />
      </IconWrapper>
      <IconWrapper
        ref={removeRef}
        style={{
          color: removeHovering ? theme.colors.red_500 : theme.colors.dark_200,
        }}
      >
        <Trash size='24' onClick={handleDelete} />
      </IconWrapper>
    </>
  );
};

export default ActionItems;

const IconWrapper = styled.div`
  cursor: pointer;
`;
